module.exports = __webpack_public_path__ + "img/qr_01.7d8e78f4.jpg";